import { cn } from "@/lib/utils";

const MAP = {
  Active: "bg-[hsl(142_71%_45%)] text-black",
  Draft: "bg-[hsl(48_96%_53%)] text-black",
  Scheduled: "bg-[hsl(199_89%_48%)] text-black",
  Expired: "bg-muted text-foreground border border-border",
};

export const StatusBadge = ({ status, className }) => (
  <span
    data-testid="admin-status-badge"
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide",
      MAP[status] || MAP.Expired,
      className
    )}
  >
    {status}
  </span>
);
